import { Account } from '../../components/Widgets/Account'
import { AppSettings } from '../../components/Widgets/AppSettings'
import { SettingsWrapper } from './styles'

export function Settings(): React.ReactNode {
  return (
    <SettingsWrapper>
      <Account />
      <AppSettings />
    </SettingsWrapper>
  )
}
